module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh",
      "overflow-y": "hidden"
    },
    style: ({
      'background': 'linear-gradient(180deg, #22C9FE 0%, #0172F2 100%)'
    })
  }, [_c('div', {
    staticClass: "machine-head",
    staticStyle: {
      "font-size": "60px",
      "letter-spacing": "10px",
      "height": "120px",
      "line-height": "120px",
      "text-shadow": "2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000",
      "position": "relative"
    },
    style: ({
      'color': '#fff',
      'background': '#ea0000'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "margin-right": "10px",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.row.score_logo ? _vm.row.score_logo : 'https://wa.ccachina.net/img/logo.58b57af4.png'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.row.title) + "\n      实时成绩\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "position": "absolute",
      "float": "right",
      "top": "20px",
      "right": "20px"
    },
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-image": "linear-gradient(#f9f400 0%, #f9f400 48%, #f9f400 100%)",
      "height": "100px",
      "letter-spacing": "0.2em",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "line-height": "100px",
      "margin": "10px",
      "text-align": "center",
      "color": "#000",
      "font-size": "50px",
      "padding": "0px 20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.start.subject_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-image": "linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%)",
      "height": "auto",
      "line-height": "140px",
      "margin": "10px",
      "text-align": "left",
      "color": "#ffffffcc",
      "font-size": "80px",
      "padding": "0",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding": "0 20px",
      "font-size": "70px",
      "background-image": "linear-gradient(180deg, #9343FE 0%, #5A1AC9 48%, #9343FE 100%)",
      "text-align": "center",
      "margin-right": "10px"
    }
  }, [_vm._v("\n   出场顺序 " + _vm._s(_vm.thisIndex + 1) + "\n  ")]), _vm._v("\n  " + _vm._s(_vm.start.mingcheng))]), _vm._v(" "), _c('div', {
    staticClass: "machine-box",
    staticStyle: {
      "margin": "10px",
      "height": "100%",
      "background-image": "linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%)"
    },
    style: ({
      'color': _vm.row.show_font_color
    })
  }, [_c('div', {
    staticClass: "machine-content"
  }, [_c('table', {
    staticClass: "machine-table",
    style: ({
      'color': _vm.row.show_font_color_2
    })
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "color": "#ca9a9a"
    }
  }, [_c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("裁判长减分")]), _vm._v(" "), (_vm.start.saiqu == 655 || _vm.start.saiqu == 654) ? _c('th', [_vm._v("公益视频加分")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.start.status == 2) ? _c('div', {
    staticStyle: {
      "background-image": "border-radius:10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v(_vm._s((parseFloat(_vm.start.score_total) + parseFloat(_vm.start.score_pen) - parseFloat(_vm.start.score_add)).toFixed(3)))]) : _c('div', {
    staticStyle: {
      "background-image": "border-radius:10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v(" - ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.start.score_pen > 0) ? _c('div', {
    staticStyle: {
      "background-image": "border-radius:10px",
      "color": "#ffffffcc",
      "line-height": "150px",
      "min-height": "204.797px"
    }
  }, [_vm._v(_vm._s(_vm.start.status == 2 ? _vm.start.score_pen : '') + "\n            "), _c('p', {
    staticStyle: {
      "color": "#fff",
      "font-size": "46px",
      "line-height": "46px"
    }
  }, [_vm._v(_vm._s(_vm.start.status == 2 ? _vm.start.comment_pen : ''))])]) : _c('div', {
    staticStyle: {
      "background-image": "",
      "border-radius": "10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v(_vm._s(_vm.start.status == 2 ? _vm.start.score_pen : '') + " ")])]), _vm._v(" "), (_vm.start.saiqu == 655 || _vm.start.saiqu == 654) ? _c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "",
      "border-radius": "10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v(_vm._s(_vm.start.status == 2 ? _vm.start.score_add : '') + " ")])]) : _vm._e()])])]), _vm._v(" "), _c('table', {
    staticClass: "machine-table",
    style: ({
      'color': _vm.row.show_font_color_2
    })
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "linear-gradient(180deg, #E04063 0%, #B71C3E 48%, #E04063 100%)",
      "border-radius": "10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v(_vm._s(_vm.start.status == 2 ? _vm.currentRank : '-'))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-image": "linear-gradient(180deg, #09BA83 0%, #007650 48%, #09BA83 100%)",
      "border-radius": "10px",
      "color": "#ffffffcc"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.start.status == 2 ? _vm.start.score_total : '-') + "\n            ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticStyle: {
      "color": "#ca9a9a"
    }
  }, [_c('th', [_vm._v("当前排名")]), _vm._v(" "), _c('th', [_vm._v("总分")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310de303","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreStartRank2.vue
// module id = 2292
// module chunks = 0